import { RemoteConfigProperties } from "../../../..";
import { frequencyToCron } from "../../../../models/looker/schedule";
import axios from "axios";
import { buildAttributionQuery } from "./utils";
export default class Scheduling {
    constructor(sdk) {
        this.sdk = sdk;
    }
    async runSchedule(settings, filters, runOnce = false) {
        const scheduleConfig = await this.buildScheduleConfig(settings, filters);
        const url = `${this.sdk.urls.burnsBaseUrl}/looker/schedules${runOnce ? "?run_once=true" : ""}`;
        try {
            return axios
                .post(url, scheduleConfig, {
                headers: {
                    "Content-Type": "application/json"
                }
            })
                .then((res) => res.data);
        }
        catch (e) {
            console.error(e);
            if (runOnce) {
                throw new Error("Failed to test run Looker schedule");
            }
            throw new Error("Failed to save Looker schedule");
        }
    }
    async save(settings, filters) {
        return this.runSchedule(settings, filters);
    }
    async test(settings, filters) {
        return this.runSchedule(settings, filters, true);
    }
    async buildScheduleConfig(settings, filters) {
        const isBlacklistEnabled = this.sdk.featureFlags.isFlagEnabled(RemoteConfigProperties.CONVERSIONS_BLACKLIST);
        const isAdvertiserAttrEnabled = this.sdk.featureFlags.isFlagEnabled(RemoteConfigProperties.SIMPLIFIED_ATTRIBUTION_INSIGHTS_ADVERTISER);
        const isUniversalPixelConversionEventsEnabled = this.sdk.featureFlags.isFlagEnabled(RemoteConfigProperties.UNIVERSAL_PIXEL_CONVERSION_EVENTS);
        const queryBody = buildAttributionQuery(filters, {
            isBlacklistEnabled,
            isAdvertiserAttrEnabled,
            isUniversalPixelConversionEventsEnabled
        });
        const newQuery = await this.sdk.looker.query.create(queryBody);
        if (!newQuery.id) {
            throw new Error("Failed to create Looker query");
        }
        return {
            // Reuse the explore buildAttributionQuery already resolved for this
            // query (queryBody.view) rather than re-deriving it from the reportType
            // filter. It picks the explore via the same OVERLAP > LINEAR > digital
            // priority that governs the query itself, so the schedule's folder can
            // never disagree with the query it's saving.
            folder_path: `attribution-dashboard/${queryBody.view}`,
            name: settings.name,
            crontab: frequencyToCron(settings.frequency),
            scheduled_plan_destination: settings.emails.map((recipient) => ({
                format: settings.format,
                apply_formatting: false,
                apply_vis: false,
                address: recipient,
                type: "email"
            })),
            query_id: newQuery.id
        };
    }
}
//# sourceMappingURL=scheduling.js.map